<template>
<div class="member-info">
        <div class="member-avatar">
            <img :src="data.memberAvatar">
        </div>
        <div class="member-detail">
            <div class="member-name">
                {{ data.memberName }}
                <div v-if="data.currentAuth" class="member-auth-desc">{{$t("已授予#!!!#src/pages/H5/Cloud/components/share/FileShareSearchMember.vue_1")}}{{data.currentAuth}}{{$t("权限#!!!#src/pages/H5/Cloud/components/share/FileShareSearchMember.vue_1")}}</div>
            </div>
            <div class="member-department">{{ data.departmentName }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Member",
    props: {
        data: {
            type: Object,
        },
    },
    data() {
        return {

        }
    },
    methods: {

    },
}
</script>

<style lang="scss" scoped>
.member-info {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;

    .member-avatar {
        width: 37px;
        height: 37px;
        margin: 4px 8px;
        border-radius: 8px;

        img {
            width: 37px;
            height: 37px;
            border-radius: 8px;
        }
    }

    .member-detail {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        width: calc(100% - 52px);

        .member-name {
            width: calc(100% - 4px);
            color: #323233;
            font-size: 14px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            line-height: 20px;
            letter-spacing: 0;
            text-align: left;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;

            .member-auth-desc {
                font-family: PingFangSC-Regular;
                font-weight: 400;
                font-size: 12px;
                color: #323233;
                letter-spacing: 0;
                line-height: 20px;
                height: 20px;
                text-align: center;
                display: flex;
                padding: 0 6px;
            }
        }

        .member-department {
            max-width: calc(100% - 4px);
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 12px;
            color: #A2A4B0;
            letter-spacing: 0;
            line-height: 17px;
            text-align: left;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            word-break: keep-all;
        }
    }
}
</style>
